import { render, staticRenderFns } from "./CopyToClipboardButton.vue?vue&type=template&id=00eb5f50&"
import script from "./CopyToClipboardButton.vue?vue&type=script&lang=ts&"
export * from "./CopyToClipboardButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports